
import {  UseFormClearErrors, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import MgpTooltip from '../../../elements/MgpTooltip/MgpTooltip';
import MgpFormRadio from '../../../elements/MgpFormRadio/MgpFormRadio';
import { ERROR_MESSAGES, PSC_DATE } from '../../../const/AppConst';
import { useEffect, useState } from 'react';
import MgpMessage from '../../../elements/MgpMessage/MgpMessage';
import MgpFormInput from '../../../elements/MgpFormInput/MgpFormInput';
import MgpFormCheckbox from '../../../elements/MgpFormCheckbox/MgpFormCheckbox';
import useAppState from '../../../context/AppContext';

type BesoinInfoFormComponentProps = {
    register: UseFormRegister<any>;
    errors: any, 
    getValues?: UseFormGetValues<any>;
    setValue?: UseFormSetValue<any>;
    clearErrors?: UseFormClearErrors<any>;
    watch?: UseFormWatch<any>
}

export default function BesoinInfoFormComponent(
    {
        register, 
        errors, 
        getValues, 
        setValue, 
        clearErrors, 
        watch} : Readonly<BesoinInfoFormComponentProps>
) {

    const earliestDate= watch?.('earliestDate');
    const [hasOldMutual, setHasOldMutual] = useState<boolean|null>(getValues?.('hasOldMutual')??null);
    const [selectedDate, setSelectedDate] = useState<string>(getValues?.('effectiveDate')??'')
    const {
        state: { updatedProposition}
    } = useAppState();

    // calculate 'Au plus tot' = today + 1 month + 2 days
    let pickedDate =  new Date();
    pickedDate.setDate(pickedDate.getDate()+2)
    pickedDate.setMonth(pickedDate.getMonth()+1)
    if(pickedDate < new Date(PSC_DATE)){
        pickedDate = new Date(PSC_DATE);
    }
    // if retirementDate > pickedDate => set pickedDate value into retirementDate  
    if (updatedProposition?.retirementDate && 
        pickedDate < new Date(updatedProposition.retirementDate) ) {
        pickedDate = new Date (updatedProposition?.retirementDate)
    }

    useEffect(()=> {
        setValue?.('effectiveDate', selectedDate);
        if(getValues?.('effectiveDate')) {
            clearErrors?.('effectiveDate')
        }
    }, [selectedDate])

    useEffect(()=> {
        if(earliestDate === true){
            setSelectedDate(pickedDate.toISOString().split('T')[0]);
        }
    }, [earliestDate])

    const onHasOldMutualChange = (value: boolean)=> {
        setHasOldMutual(value);
        setSelectedDate('')
        setValue?.('effectiveDate', '')
        clearErrors?.('effectiveDate')
        if(value === false){
            setValue?.('earliestDate', false)
        }
    }

    const minDate = ()=> {
        let value
        let today = new Date();
        let PSC_date = new Date(PSC_DATE);
        if(hasOldMutual?.toString() === 'true'){
            value = pickedDate > PSC_date ? pickedDate : PSC_date
        } else {
            value = today > PSC_date ? today : PSC_date
        }
        return value.toISOString().split('T')[0]
    }

    return (             
        <>
            <h2 className='card-title bleu'>Date d'effet </h2>
            <div className='m-y-sm'>
                <div className='form-check-label fw-medium text'>
                    <span>
                        J'ai une complémentaire santé depuis plus d'un an et 
                        je mandate la MGP pour effectuer les formalités de résiliation 
                        en mon nom, conformément à l'article L.221-10-2 du Code de la mutualité
                    </span>
                    <MgpTooltip text="Si vous avez souscrit depuis plus d'un an à une complémentaire santé, vous avez la possibilité 
                    de résilier celle-ci à tout moment sans motif. Si vous répondez oui, la MGP effectuera les démarches de résiliation 
                    auprès de votre ancien organisme et s'assurera de la continuité de votre couverture.">
                    <p className='info-badge info-icon' style={{marginTop: '-16px'}}>i</p></MgpTooltip>
                </div>

                <div className='form-row va-center jc-start' style={{width: "max-content"}} >     
                    <MgpFormRadio 
                            id='hasOldMutual'  
                            value='true' 
                            label='Oui' 
                            register={register} 
                            errors={errors} 
                            onClick={()=>{onHasOldMutualChange(true)}}
                    />
                    <MgpFormRadio 
                            id='hasOldMutual' 
                            value='false' 
                            label='Non' 
                            register={register} 
                            errors={errors}  
                            onClick={()=>{onHasOldMutualChange(false)}}
                    />
                </div>     

                {errors?.hasOldMutual 
                &&<p className="error">{ERROR_MESSAGES.requiredMsg}</p>
                }

            </div>

            <p className='fw-medium text'>Date d'adhésion souhaitée</p>
            
            {hasOldMutual 
            && getValues?.('hasOldMutual').toString() === 'true'
            &&<div className='form-group form-check mw-100'>     
                <MgpFormCheckbox 
                        register={register}
                         errors={errors} 
                         id='earliestDate' 
                         label='Au plus tôt' 
                />
            </div>                  
            }

            <div className='form-row' >
                <div className='form-group mw-50'>
                {earliestDate !== true
                && <MgpFormInput
                        label=""
                        id="effectiveDate"
                        labelFontWeight='medium'
                        type='date'
                        register={register}
                        value={selectedDate}
                        errors={errors}
                        min={minDate()}
                        onChange={(e)=> setSelectedDate(e.target.value)}
                    />}
                </div>
            </div>
           
            {earliestDate 
            && <MgpMessage
                    type='info' 
                    message="Au lendemain de la prise d'effet de la résiliation auprès de votre ancien organisme" /> 
            }

          


        </>         
  )
}
